
import { defineComponent } from "vue";

export default defineComponent({
  name: "SearchBox",
  setup() {
    return {};
  }
});
